import React, { memo, useEffect, useCallback } from "react";
import "./index.scss";
import { useHistory } from "react-router-dom";
import { setScreenSaverStatusAction } from "../../store/control/actions";
import { useDispatch, useSelector } from "react-redux";
import { useRPC } from "../../hooks/rpc";
import { onClickHandler } from "../../utils/onclick";
import { setPasswordAction } from "../../store/control/actions";

let timerWithDigitalClock;
export const DigitalClock = memo(function DigitalClock() {
  const history = useHistory();
  const dispatch = useDispatch();
  const passStatus = useSelector((state) => state.control.passwordStatus);
  const [rpc] = useRPC();

  let d = new Date();
  const time = d.toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const date = d.toLocaleDateString("tr-TR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  useEffect(() => {
    timerWithDigitalClock = setInterval(() => {
      history.push("/digital-clock");
    }, 60000);
    return () => {
      clearInterval(timerWithDigitalClock);
    };
  }, [history, dispatch]);

  const hideDigital = useCallback(() => {
    clearInterval(timerWithDigitalClock);
    dispatch(setScreenSaverStatusAction(null));

    if (passStatus === false) {
      history.push("/lock");
      dispatch(setPasswordAction(null));
    } else {
      history.push("/");
    }

    rpc.touchEvent().then();
  }, [history, passStatus, dispatch, rpc]);
  

  return (
    <div className="container-clock" {...onClickHandler(hideDigital)}>
      <div id="digital-div1">
        <p id="digital-time">{time}</p>
        <p id="digital-date">{date}</p>
        <div id="digital-text"></div>
      </div>
    </div>
  );
});
